/* @flow */

import * as React from 'react';

import {StackLegacy} from '../layout';

import './empty-timeline-cell.module.css';

type Props = {
    lineOneWidth: string,
    lineTwoWidth: string,
    contentWidth: string,
    contentHeight: string,
    noTopLine?: boolean,
};

export function EmptyTimelineCell(props: Props) {
    return (
        <StackLegacy spacing={8}>
            {!props.noTopLine ? <div styleName='top-line' /> : undefined}
            <div styleName='container'>
                <div styleName='profile' />
                <div styleName='entryHeader'>
                    <StackLegacy spacing={8}>
                        <div styleName='row' style={{width: props.lineOneWidth}} />
                        <div styleName='row' style={{width: props.lineTwoWidth}} />
                    </StackLegacy>
                </div>
            </div>
            <div styleName='container'>
                <div styleName='line' />
                <div
                    styleName='content'
                    style={{height: props.contentHeight, width: props.contentWidth}}
                />
            </div>
        </StackLegacy>
    );
}
